<lv-photo-help [photoType]="photoType" lvCloseOverlay withKeyboard="esc">
  <lv-retake-photo
    [session]="session"
    [photoType]="photoType"
    (photoTaken)="onPhotoTaken($event)"
    (photoAccepted)="onPhotoAccepted()"
  ></lv-retake-photo>
</lv-photo-help>
